/*
  RESADE rs-fragen.js (Feedback Runde 1, 25.09.2026, T5)
  Weiches Auf- und Zuklappen aller Aufklapper details.rs-frage (FAQ-Seite, Produktseite, Startseite,
  rs-aufklapper, rs-seitentext). Grundlage bleibt details und summary: ohne JavaScript, bei
  reduzierter Bewegung (System oder Theme-Einstellung html.ohne-bewegung) und ohne Web Animations
  klappt der Browser wie gewohnt sofort auf und zu.
  Animiert wird die Hoehe des details-Elements zwischen zu (nur die Frage) und offen (Frage und
  Antwort), dazu die Deckkraft der Antwort. Ein zweiter Klick waehrend der Bewegung kehrt sie von der
  aktuellen Hoehe aus um. Beim Zuklappen traegt das details die Klasse rs-frage--schliesst, damit das
  Zeichen (rs-fragen.css) sofort wieder das Plus zeigt; das Attribut open faellt erst am Ende weg.
  Wird mehrfach eingebunden (je Section), laeuft aber nur einmal (Ereignis am document, auch fuer
  Sections, die der Theme-Editor neu laedt).
  Runde 3c (E-151, JS-10): Gruppen mit dem Attribut name (nur einer offen, etwa die Aufklapper der
  Kaufbuehne) schliesst der Browser sofort und ohne Bewegung; der angeklickte Kopf sprang dann. Mit
  JavaScript merkt sich das Skript den Namen in data-rs-gruppe, nimmt name weg und schliesst den offenen
  Nachbarn selbst, weich oder bei reduzierter Bewegung sofort. Ohne JavaScript bleibt das native name.
  Runde 4 (E-153, B14): Ein offener Nachbar oberhalb schliesst sofort, und die Seite rueckt um seine Hoehe nach, damit
  der angetippte Kopf stehen bleibt (vorher rutschte er bei 360 px um rund 480 px nach oben); darunter weiter weich.
  Runde 7 (E-159): Zeigt ein Sprunglink auf ein Ziel in einem geschlossenen Aufklapper (etwa #technik in den
  Produktdetails), oeffnet das Skript ihn vorher, beim Klick, beim Laden mit Anker und bei hashchange.
  Runde 20 (E-178, Denny: Lieferumfang als erster Aufklapper, offen, immer nur einer offen): Beim Sprung schliessen
  die Nachbarn der Gruppe sofort mit, bevor der Browser scrollt; sonst schloss toggle den offenen Lieferumfang ueber
  #technik erst danach, und der Sprung landete um dessen Hoehe zu tief. Beim Laden und bei hashchange hat der Browser
  schon gescrollt, dort springt das Skript danach noch einmal auf das Ziel.
*/
(function () {
  'use strict';
  if (window.rsFragenAn) return;
  window.rsFragenAn = true;

  var DAUER = 260;
  var KURVE = 'cubic-bezier(.2, .7, .3, 1)';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function still() {
    return (mq && mq.matches) || document.documentElement.classList.contains('ohne-bewegung');
  }

  function zuHoehe(d, s) {
    var cs = getComputedStyle(d);
    return s.offsetHeight +
      (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) +
      (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
  }

  function antwortVon(d) {
    for (var i = 0; i < d.children.length; i++) {
      if (d.children[i].tagName !== 'SUMMARY') return d.children[i];
    }
    return null;
  }

  function aufraeumen(d) {
    d.style.overflow = '';
    d.classList.remove('rs-frage--bewegt');
  }

  function bewege(d, von, bis, schliessen) {
    var antwort = antwortVon(d);
    d.style.overflow = 'hidden';
    d.classList.add('rs-frage--bewegt');
    var a = d.animate(
      { height: [von + 'px', bis + 'px'] },
      { duration: DAUER, easing: KURVE, fill: 'forwards' }
    );
    var b = null;
    if (antwort && typeof antwort.animate === 'function') {
      b = antwort.animate(
        { opacity: schliessen ? [1, 0] : [0, 1] },
        { duration: schliessen ? DAUER * 0.6 : DAUER, easing: 'linear', fill: 'forwards' }
      );
    }
    d._rsLauf = { a: a, b: b };
    a.onfinish = function () {
      if (!d._rsLauf || d._rsLauf.a !== a) return;
      if (schliessen) {
        d.open = false;
        d.classList.remove('rs-frage--schliesst');
      }
      d._rsLauf = null;
      a.cancel();
      if (b) b.cancel();
      aufraeumen(d);
    };
  }

  function abbrechen(d) {
    var lauf = d._rsLauf;
    if (!lauf) return;
    d._rsLauf = null;
    lauf.a.cancel();
    if (lauf.b) lauf.b.cancel();
  }

  function gruppenUebernehmen(wurzel) {
    var liste = (wurzel || document).querySelectorAll('details.rs-frage[name]');
    for (var i = 0; i < liste.length; i++) {
      liste[i].setAttribute('data-rs-gruppe', liste[i].getAttribute('name'));
      liste[i].removeAttribute('name');
    }
  }

  // Sofort scrollen, auch wenn das Theme html auf scroll-behavior: smooth setzt
  function springen(dy) {
    var h = document.documentElement;
    var alt = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollBy(0, dy);
    h.style.scrollBehavior = alt;
  }

  function nachbarnSchliessen(d, weich, ausgleich) {
    var gruppe = d.getAttribute('data-rs-gruppe');
    if (!gruppe) return;
    var ds = d.querySelector('summary');
    var vorher = ds ? ds.getBoundingClientRect().top : 0;
    var obenZu = false;
    var alle = document.querySelectorAll('details.rs-frage[data-rs-gruppe]');
    for (var i = 0; i < alle.length; i++) {
      var o = alle[i];
      if (o === d || o.getAttribute('data-rs-gruppe') !== gruppe) continue;
      if (!o.open || o.classList.contains('rs-frage--schliesst')) continue;
      var os = o.querySelector('summary');
      var davor = ausgleich && !!(o.compareDocumentPosition(d) & Node.DOCUMENT_POSITION_FOLLOWING);
      if (davor) obenZu = true;
      if (weich && !davor && os && typeof o.animate === 'function') {
        var hoch = o.getBoundingClientRect().height;
        abbrechen(o);
        o.classList.add('rs-frage--schliesst');
        bewege(o, hoch, zuHoehe(o, os), true);
      } else {
        abbrechen(o);
        o.classList.remove('rs-frage--schliesst');
        aufraeumen(o);
        o.open = false;
      }
    }
    if (obenZu && ds) {
      var dy = ds.getBoundingClientRect().top - vorher;
      if (Math.abs(dy) > 1) springen(dy);
    }
  }

  // Oeffnet der Browser einen Aufklapper selbst (Suche im Seitentext, Sprung auf einen Anker darin), schliesst
  // ohne name niemand die Nachbarn; toggle blubbert nicht, deshalb im Capture-Modus am document
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.hasAttribute('data-rs-gruppe')) return;
    nachbarnSchliessen(d, false, false);
  }, true);

  gruppenUebernehmen(document);
  document.addEventListener('DOMContentLoaded', function () { gruppenUebernehmen(document); });

  function ankerOeffnen(hash, nachrollen) {
    if (!hash || hash.length < 2) return;
    var el = null;
    try { el = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (f) { return; }
    var d = el && el.closest ? el.closest('details.rs-frage') : null;
    if (!d || d.open) return;
    d.open = true;
    // E-178: synchron, nicht erst ueber toggle
    nachbarnSchliessen(d, false, false);
    if (nachrollen && typeof el.scrollIntoView === 'function') el.scrollIntoView();
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var u = null;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (f) { return; }
    if (u.pathname !== location.pathname || !u.hash) return;
    // Beim Klick scrollt der Browser erst nach diesem Aufruf, mit schon geschlossenen Nachbarn
    ankerOeffnen(u.hash, false);
  }, true);
  window.addEventListener('hashchange', function () { ankerOeffnen(location.hash, true); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ankerOeffnen(location.hash, true); });
  } else {
    ankerOeffnen(location.hash, true);
  }
  document.addEventListener('shopify:section:load', function (e) { gruppenUebernehmen(e.target); });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0) return;
    var s = e.target && e.target.closest ? e.target.closest('summary') : null;
    if (!s) return;
    var d = s.parentElement;
    if (!d || d.tagName !== 'DETAILS' || !d.classList.contains('rs-frage')) return;
    if (d.querySelector('summary') !== s) return;
    if (still() || typeof d.animate !== 'function') {
      // Ohne Bewegung klappt der Browser selbst; die Gruppe schliesst dann sofort
      if (!d.open) nachbarnSchliessen(d, false, true);
      return;
    }

    e.preventDefault();
    var jetzt = d.getBoundingClientRect().height;
    var schliesst = d.classList.contains('rs-frage--schliesst');
    abbrechen(d);

    if (d.open && !schliesst) {
      d.classList.add('rs-frage--schliesst');
      bewege(d, jetzt, zuHoehe(d, s), true);
    } else {
      d.classList.remove('rs-frage--schliesst');
      nachbarnSchliessen(d, true, true);
      if (!d.open) {
        jetzt = zuHoehe(d, s);
        d.open = true;
      }
      d.style.overflow = '';
      var voll = d.getBoundingClientRect().height;
      bewege(d, jetzt, voll, false);
    }
  });
})();
